import CastomTextField from "./CastomTextField.vue"
import GoalIcon from "./GoalIcon.vue"
const GlobalComponents = {
  install (Vue) {
    Vue.component(CastomTextField.name, CastomTextField)
    Vue.component(GoalIcon.name, GoalIcon)
  }
}

export default GlobalComponents